import {requests} from '../../services';
import {STATISTICS_URL} from '../../utils/Endpoints';
import {IStatisticData} from "./dto/iStatistic";

export const StatisticsService = {
    getStatistics: (userType: string): Promise<IStatisticData> => requests.get(`${STATISTICS_URL}/${userType}`),
}
